<template>
  <v-expansion-panel-content
    hide-actions
    :id="serviceId"
    class="service-component"
    v-model="expanded"
    lazy
  >
    <div class="service-header" slot="header">
      <div class="right pa-1">
        <div class="fa fa-exchange rotate90 light exchange-service" />
        <div
          class="duplicate fa fa-copy light"
          @click.stop="$emit('duplicateService', service.id)"
        />
        <div
          class="fa fa-trash light"
          :id="`delete-service-${service.id}`"
          @click.stop="$emit('deleteService', service.id)"
        />
      </div>
      <div class="inline">
        <div class="fa fa-chevron-right light" />
        <div class="name">{{ service.attributes.name }}</div>
      </div>
    </div>
    <service-form :service="service" :expanded="expanded" />
  </v-expansion-panel-content>
</template>

<script>
import ServiceForm from './ServiceForm'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  components: {
    ServiceForm,
  },
  computed: {
    serviceId() {
      return `service-${this.service.id}`
    },
  },
  props: ['service'],
}
</script>

<style scoped>
.fa-chevron-right {
  transition: all 0.5s;
  margin-right: 0.5rem;
}

.fa {
  transition: color 0.3s;
}

.fa-copy:hover,
.fa-exchange:hover {
  color: black;
}

.fa-exchange {
  cursor: move;
}

.fa-trash:hover {
  color: #d53636;
}

.service-header .name {
  font-size: 1.5rem;
  font-weight: 100;
}

.service-header .right div {
  margin-left: 0.5rem;
}

.v-expansion-panel__container.service {
  background-color: #f9f9f9;
}

.v-expansion-panel__container--active .fa-chevron-right {
  transform: rotate(90deg);
}
</style>

<style lang="scss">
.service-component {
  .v-expansion-panel__header {
    height: auto;
    min-height: 48px;
    .name {
      display: inline;
    }
  }
}
</style>
